import React, { useState } from "react";
import "../Headers/Sidebar/Sidebar.scss";
import product_icon from "../../Assets/Images/product-icon.png";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";

function CouponItems() {
  const [menuOpenCoupen, setMenuOpenCoupen] = useState(false);

  return (
    <div className="text-decoration-none">
      <li
        onClick={() => setMenuOpenCoupen(!menuOpenCoupen)}
        aria-controls="example-collapse-text"
        aria-expanded={menuOpenCoupen}
      >
        <div className="d-flex">
          <img className="sidebar-icons" src={product_icon} />  
          <div className="sidebar-text">property</div>
        </div>
        {menuOpenCoupen === false ? (
          <IoIosArrowForward className="sidebar-menu-icon" />
        ) : (
          <IoIosArrowDown className="sidebar-menu-icon" />
        )}
      </li>

      <Collapse in={menuOpenCoupen}>
        <div id="example-collapse-text">
          <Link
            className="text-dark text-decoration-none"
            style={{ fontSize: "13px" }}
            to="/PropertyView"
          >
            <li className="mx-2">View Property</li>
          </Link>
          
        </div>
      </Collapse>
    </div>
  );
}

export default CouponItems;